export default "undo redo | casechange blocks | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlst checklist outdent indent  |insertdatetime addSignature |preview fullscreen export print   "